<template>
  <div class="ios-tabbar">
    <ul>
      <li>
        <a @click="handleConfirm">
          <i class="iconfont icon-cailiaoxiezuo"></i>
          <span>{{ info.language_list.today }}</span></a
        >
      </li>
      <li class="active">
        <a>
          <i class="iconfont icon-huojian"></i>
          <span>{{ info.language_list.games }}</span></a
        >
      </li>
      <li>
        <a @click="handleConfirm">
          <i class="iconfont icon-shuju"></i>
          <span>{{ info.language_list.apps }}</span></a
        >
      </li>
      <li>
        <a @click="handleConfirm">
          <i class="iconfont icon-icon_fangdajing"></i>
          <span>{{ info.language_list.search }}</span></a
        >
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const info = computed(() => store.state.appInfo);

const emit = defineEmits(['confirm']);

const handleConfirm = () => {
  emit('confirm');
};
</script>

<style lang="scss" scoped>
.ios-tabbar {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 3;
  height: 75px;
  background: #f6f6f8;
  font-size: 12px;
  ul {
    display: flex;
    height: 75px;
    align-items: center;
    justify-content: center;
  }
  ul li {
    flex: 1;
    text-align: center;
    overflow: hidden;
  }
  ul span {
    display: block;
    white-space: nowrap;
  }
  ul li a {
    display: block;
    margin: 0 auto;
    width: 50px;
    .iconfont {
      font-size: 20px;
      color: #999;
    }
  }
  ul li a:hover,
  ul li.active {
    color: var(--main-color);
    .iconfont {
      color: var(--main-color);
    }
  }
}
</style>
